import React from "react";
import PropTypes from "prop-types";
import { parseUserProfileToFitProfile } from "./fit-profile-helpers";
import FormattingUtils from "helpers/FormattingUtils";
import { getAge } from "helpers/date-helpers";

const FitProfileSummary = ({ userProfile }) => {
  if (!userProfile) return null;

  const parsed = parseUserProfileToFitProfile(userProfile);

  const { profiles = {}, height, weight, bodyType, bustSize, dateOfBirth } = parsed;

  const values = [
    profiles.primarySize && `Size ${profiles.primarySize}`,
    height && FormattingUtils.formatHeight(height),
    weight && `${weight}lbs`,
    bodyType,
    bustSize,
    dateOfBirth && `${getAge(dateOfBirth)} yrs`,
  ].filter(Boolean);

  return (
    <div className="w-full shrink-0">
      {values.length === 0 ? (
        <div className="text-sm text-mediumGray italic">Fit profile info not available.</div>
      ) : (
        <div className="flex flex-wrap items-center text-md font-medium text-onyx">
          {values.map((value, index) => (
            <React.Fragment key={index}>
              <span>{value}</span>
              {index !== values.length - 1 && <span className="mx-2 text-gray-300">|</span>}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

FitProfileSummary.propTypes = {
  userProfile: PropTypes.object.isRequired,
};

export default FitProfileSummary;
